import { TImage } from "@input-output-hk/essential-cardano-models";
import { MaybeApiError } from "../hooks/useSWR";

type UploadImageApiResponse = MaybeApiError<{ image: TImage }>;

export async function uploadImage(file: File): Promise<UploadImageApiResponse> {
  const formData = new FormData();
  formData.set("image", file);

  const resp = await fetch("/api/image", {
    method: "POST",
    body: formData
  });
  return resp.json();
}
